"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _default = function _default(_ref) {
  var onClick = _ref.onClick,
      _ref$threadCount = _ref.threadCount,
      threadCount = _ref$threadCount === void 0 ? 0 : _ref$threadCount;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "px-8"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "select-none w-full flex items-center justify-center bg-secondary rounded-xl p-6"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-primary"
  }, /*#__PURE__*/_react["default"].createElement("span", null, t('threadList.emptyTrash.title', {
    count: threadCount
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "pl-1 font-bold cursor-pointer",
    onClick: onClick
  }, t('threadList.emptyTrash.action')))));
};

exports["default"] = _default;
//# sourceMappingURL=index.js.map